import { Component, OnInit, ViewChild, ElementRef, Input, OnDestroy, ViewChildren, QueryList, ChangeDetectorRef } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { GeneralService } from '../services/general.service';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { map, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

Chart.register(...registerables);

@Component({
  selector: 'app-monitiring-dashboard',
  templateUrl: './monitiring-dashboard.component.html',
  styleUrls: ['./monitiring-dashboard.component.scss']
})
export class MonitiringDashboardComponent implements OnInit, OnDestroy {
  label: string;
    private subscription: Subscription;
  Devices: any[] = [];
  @ViewChildren('historyCanvas') historyCanvases: QueryList<ElementRef>;
  private readonly databaseURL = 'https://i-monitor-19ba2-default-rtdb.firebaseio.com/';
  private readonly secret = '8G9l51WypQ5TlYCmB8qsoLzj89fn0ZM4YKGLUxFy';
  private readonly collectionPath = 'itemTypes';
  ItemTypes: any[];
  Branches: any[]=[];
  id: string;
  currentuser: any;
  searchForm: FormGroup;
  private lastScrollPosition: number = 0;

  constructor(private cdRef: ChangeDetectorRef,public GeneralService: GeneralService, private http: HttpClient,    private formBuilder: FormBuilder,
  ) {
    const user = localStorage.getItem("userid");
    if (user) {
      this.id = user;
      this.getBranchByClientId(user)
      localStorage.setItem("userid", this.id);
      console.log("Come From Admin");
    } else {
      this.currentuser = JSON.parse(localStorage.getItem("currentuser"));
      console.log(this.currentuser)
      this.id = this.currentuser.clientid;
      this.getBranchByClientId(this.currentuser.clientid)

    }
  }

  getBranchByClientId(id) {
    this.GeneralService.getBranchByClientId(id).then(async res => {
      console.log(res)
      this.Branches = await res;
      this.search(res);
      console.log(this.Branches, "our branches");
      
    })
  }
 
  
  search(branches) {
    this.subscription = this.GeneralService.getdataiot(this.id)
      .subscribe({
        next: (data) => {
          // Store current scroll position before update
          this.lastScrollPosition = window.scrollY;
          
          console.log(data)
          
          this.Branches = branches.map(branch => {
            // Find the matching device data using branch ID
            
            const matchingDeviceData = data.find(dd => dd.id === branch.id);
            if (matchingDeviceData) {
              // Extract devices from the device data object
              const Orignaldevices: any[] = Object.entries(matchingDeviceData)
                .filter(([key, value]) => key !== 'id' && typeof value === 'object')
                .map(([_, value]) => value as any);
                
              return {
                ...branch,
                Orignaldevices
              };
            }
            
          });
          console.log(this.Branches);
          this.Branches.map(br=>{
            if (br?.Orignaldevices && br?.Orignaldevices.length > 0) {

              // this.Devices = data?.map(device => ({
              // ...device,
              // adjustedValue: this.calculateAdjustedValue(device.temperature),
              // markerConfig: this.getMarkerConfig(device.humidity),
              // markerConfigTemp: this.getMarkerConfig(device.temperature),
              // label: `${device.temperature.toFixed(0)}${device.temperature ? 'C°' : '%'}`
              // }));
              br['Devices']=[]
              br?.Orignaldevices.map(device => {
                console.log(device.type);
                const type = this.ItemTypes.filter(res => res.id === device.type);
                console.log(type);
                const item = type[0]; // Get the first matching item
  
                // Extract and convert values to numbers
                const firstholdtemp = parseFloat(item?.firstholdtemp);
                const secondholdtemp = parseFloat(item?.secondholdtemp);
                const thirdholdtemp = parseFloat(item?.thirdholdtemp);
  
                if (device.humidity) {
                  if (firstholdtemp > secondholdtemp && firstholdtemp > thirdholdtemp) {
  
                    br['Devices'].push(
                      {
                        ...device,
                        devicetype:"Temprature",
                        // adjustedValue: this.calculateAdjustedValue(device.temperature),
                        adjustedValue: device.temperature,
                        markerConfig: {
                          [type[0].firstmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].secondmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].thirdmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].fourthmarkertemp]: { color: '#2e2e2e', size: 12, label: type[0].fourthmarkertemp, type: 'line', fontSize: '12px' }
                        },
                        label: `${device.temperature.toFixed(0)} C°`,
                        thresholdsConfig: {
                          [type[0].thirdholdtemp]: { color: "red", bgOpacity: 0.2 },
                          [type[0].secondholdtemp]: { color: "orange", bgOpacity: 0.2 },
                          [type[0].firstholdtemp]: { color: "green", bgOpacity: 0.2 }
                        },
                        originalMin: type[0].firstmarkertemp,
                        originalMax: type[0].fourthmarkertemp,
                        gaugeMax: type[0].fourthmarkertemp,
                        gaugeMin: type[0].firstmarkertemp
                      }
  
                      //   ...device,
                      //   // adjustedValue: this.calculateAdjustedValue(device.temperature),
                      //   adjustedValue:device.temperature,
                      //   markerConfig: {
                      //     "0": { color: '#2e2e2e', size: 12, label: "0", type: 'line', fontSize: '12px' },
                      //     "50": { color: '#2e2e2e', size: 10, label: "50", type: 'line', fontSize: '12px' },
                      //     "70": { color: '#2e2e2e', size: 10, label: "70", type: 'line', fontSize: '12px' },
                      //    "100" : { color: '#2e2e2e', size: 10, label:  "100", type: 'line', fontSize: '12px' }
                      //   },
                      //   label: `${device.temperature.toFixed(0)} C°`,
                      //   thresholdsConfig:{
                      //     "0": { color: "red", bgOpacity: 0.2 },
                      //     "50": { color: "orange", bgOpacity: 0.2 },
                      //     "60": { color: "green", bgOpacity: 0.2 }
  
                      //   },
  
                      //   gaugeMax:100, 
                      //   gaugeMin:0
                      // }
                    );
                    console.log(br['Devices'])
  
                  } else {
                    br['Devices'].push(
                      {
                        ...device,
                        // adjustedValue: this.calculateAdjustedValue(device.temperature),
                        adjustedValue: device.temperature,
                        devicetype:"Temprature",
                        markerConfig: {
                          [type[0].firstmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].secondmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].thirdmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].fourthmarkertemp]: { color: '#2e2e2e', size: 12, label: type[0].fourthmarkertemp, type: 'line', fontSize: '12px' }
                        },
                        label: `${device.temperature.toFixed(0)} C°`,
                        thresholdsConfig: {
                          [type[0].firstholdtemp]: { color: "green", bgOpacity: 0.2 },
                          [type[0].secondholdtemp]: { color: "orange", bgOpacity: 0.2 },
                          [type[0].thirdholdtemp]: { color: "red", bgOpacity: 0.2 }
                        },
                        originalMin: type[0].firstmarkertemp,
                        originalMax: type[0].fourthmarkertemp,
                        gaugeMax: type[0].fourthmarkertemp,
                        gaugeMin: type[0].firstmarkertemp
                      }
  
                      //   ...device,
                      //   // adjustedValue: this.calculateAdjustedValue(device.temperature),
                      //   adjustedValue:device.temperature,
                      //   markerConfig: {
                      //     "0": { color: '#2e2e2e', size: 12, label: "0", type: 'line', fontSize: '12px' },
                      //     "50": { color: '#2e2e2e', size: 10, label: "50", type: 'line', fontSize: '12px' },
                      //     "70": { color: '#2e2e2e', size: 10, label: "70", type: 'line', fontSize: '12px' },
                      //    "100" : { color: '#2e2e2e', size: 10, label:  "100", type: 'line', fontSize: '12px' }
                      //   },
                      //   label: `${device.temperature.toFixed(0)} C°`,
                      //   thresholdsConfig:{
                      //     "0": { color: "red", bgOpacity: 0.2 },
                      //     "50": { color: "orange", bgOpacity: 0.2 },
                      //     "60": { color: "green", bgOpacity: 0.2 }
  
                      //   },
  
                      //   gaugeMax:100, 
                      //   gaugeMin:0
                      // }
                    );
                  }
  
  
                  br['Devices'].push({
                    ...device,
                    // adjustedValue: this.calculateAdjustedValue(device.humidity),
                    adjustedValue: device.humidity,
                    devicetype:"Humidity",
                    markerConfig: {
                      [type[0].firstmarkerhum]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkerhum, type: 'line', fontSize: '12px' },
                      [type[0].secondmarkerhum]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkerhum, type: 'line', fontSize: '12px' },
                      [type[0].thirdmarkerhum]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkerhum, type: 'line', fontSize: '12px' },
                      [type[0].fourthmarkerhum]: { color: '#2e2e2e', size: 10, label: type[0].fourthmarkerhum, type: 'line', fontSize: '12px' }
                    },
                    label: `${device.humidity.toFixed(0)} %`,
                    thresholdsConfig: {
                      [type[0].firstholdhum]: { color: "green", bgOpacity: 0.2 },
                      [type[0].secondholdhum]: { color: "orange", bgOpacity: 0.2 },
                      [type[0].thirdholdhum]: { color: "red", bgOpacity: 0.2 }
                    },
                    originalMin: type[0].firstmarkerhum,
                    originalMax: type[0].fourthmarkerhum,
                    gaugeMax: type[0].fourthmarkerhum,
                    gaugeMin: type[0].firstmarkerhum
                  });

                }
                else {
                  
                  if (firstholdtemp > secondholdtemp && firstholdtemp > thirdholdtemp) {
                    br['Devices'].push(
                      {
                        ...device,
                        // adjustedValue: this.calculateAdjustedValue(device.temperature),
                        adjustedValue: device.temperature,
                        devicetype:"Temprature",
                        markerConfig: {
                          [type[0].firstmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].secondmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].thirdmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].fourthmarkertemp]: { color: '#2e2e2e', size: 12, label: type[0].fourthmarkertemp, type: 'line', fontSize: '12px' }
                        },
                        label: `${device.temperature.toFixed(0)} C°`,
                        thresholdsConfig: {
                          [type[0].thirdholdtemp]: { color: "red", bgOpacity: 0.2 },
                          [type[0].secondholdtemp]: { color: "orange", bgOpacity: 0.2 },
                          [type[0].firstholdtemp]: { color: "green", bgOpacity: 0.2 },
  
                        },
                        originalMin: type[0].firstmarkertemp,
                        originalMax: type[0].fourthmarkertemp,
                        gaugeMax: type[0].fourthmarkertemp,
                        gaugeMin: type[0].firstmarkertemp
                      }
  
                      //   ...device,
                      //   // adjustedValue: this.calculateAdjustedValue(device.temperature),
                      //   adjustedValue:device.temperature,
                      //   markerConfig: {
                      //     "0": { color: '#2e2e2e', size: 12, label: "0", type: 'line', fontSize: '12px' },
                      //     "50": { color: '#2e2e2e', size: 10, label: "50", type: 'line', fontSize: '12px' },
                      //     "70": { color: '#2e2e2e', size: 10, label: "70", type: 'line', fontSize: '12px' },
                      //    "100" : { color: '#2e2e2e', size: 10, label:  "100", type: 'line', fontSize: '12px' }
                      //   },
                      //   label: `${device.temperature.toFixed(0)} C°`,
                      //   thresholdsConfig:{
                      //     "0": { color: "red", bgOpacity: 0.2 },
                      //     "50": { color: "orange", bgOpacity: 0.2 },
                      //     "60": { color: "green", bgOpacity: 0.2 }
  
                      //   },
  
                      //   gaugeMax:100, 
                      //   gaugeMin:0
                      // }
                    );
  
                  }
                  else {
                    //هنا القديم 
                    // br['Devices'].push(
                    //   {
                    //     ...device,
                    //     // adjustedValue: this.calculateAdjustedValue(device.temperature),
                    //     adjustedValue: device.temperature,
                    //       // adjustedValue: device.temperature >= 0 ? device.temperature : this.calculateAdjustedValue(device.temperature,device.firstholdtemp,device.thirdholdtemp),
                    //     devicetype:"Temprature",

                    //     markerConfig: {
                    //       [type[0].firstmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkertemp, type: 'line', fontSize: '12px' },
                    //       [type[0].secondmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkertemp, type: 'line', fontSize: '12px' },
                    //       [type[0].thirdmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkertemp, type: 'line', fontSize: '12px' },
                    //       [type[0].fourthmarkertemp]: { color: '#2e2e2e', size: 12, label: type[0].fourthmarkertemp, type: 'line', fontSize: '12px' }
                    //     },
                    //     label: `${device.temperature.toFixed(0)} C°`,
                    //     thresholdsConfig: {
                    //       [type[0].firstholdtemp]: { color: "green", bgOpacity: 0.2 },
                    //       [type[0].secondholdtemp]: { color: "orange", bgOpacity: 0.2 },
                    //       [type[0].thirdholdtemp]: { color: "red", bgOpacity: 0.2 }
  
                    //     } ,
                    //     originalMin: type[0].firstmarkertemp,
                    //     originalMax: type[0].fourthmarkertemp,
                    //     gaugeMax: type[0].fourthmarkertemp,
                    //     gaugeMin: type[0].firstmarkertemp
                    //   }
  
                    //   //   ...device,
                    //   //   // adjustedValue: this.calculateAdjustedValue(device.temperature),
                    //   //   adjustedValue:device.temperature,
                    //   //   markerConfig: {
                    //   //     "0": { color: '#2e2e2e', size: 12, label: "0", type: 'line', fontSize: '12px' },
                    //   //     "50": { color: '#2e2e2e', size: 10, label: "50", type: 'line', fontSize: '12px' },
                    //   //     "70": { color: '#2e2e2e', size: 10, label: "70", type: 'line', fontSize: '12px' },
                    //   //    "100" : { color: '#2e2e2e', size: 10, label:  "100", type: 'line', fontSize: '12px' }
                    //   //   },
                    //   //   label: `${device.temperature.toFixed(0)} C°`,
                    //   //   thresholdsConfig:{
                    //   //     "0": { color: "red", bgOpacity: 0.2 },
                    //   //     "50": { color: "orange", bgOpacity: 0.2 },
                    //   //     "60": { color: "green", bgOpacity: 0.2 }
  
                    //   //   },
  
                    //   //   gaugeMax:100, 
                    //   //   gaugeMin:0
                    //   // }
                    // );
                      //هنا بتاع الحاجات اللي بتيجي بسالب 
                      const firsttemp = Math.floor(type[0].firstmarkertemp); // 42 (truncated)
                      if(firsttemp < 0){
                        br['Devices'].push({
                          ...device,
                          adjustedValue: this.calculateAdjustedValue(
                            device.temperature,
                            Number(type[0].firstmarkertemp),  // -30
                            Number(type[0].fourthmarkertemp)  // -5
                          ),
                          devicetype: "Temprature",
                          
                          markerConfig: {
                            [this.calculateAdjustedValue(
                              Number(type[0].firstmarkertemp),  // -30
                              Number(type[0].firstmarkertemp),  // -30
                              Number(type[0].fourthmarkertemp)  // -5
                            )]: { 
                              color: '#2e2e2e', 
                              size: 10, 
                              label: type[0].firstmarkertemp,
                              type: 'line', 
                              fontSize: '12px',
                              visible: true
                            },
                            [this.calculateAdjustedValue(
                              Number(type[0].secondmarkertemp),  // -20
                              Number(type[0].firstmarkertemp),   // -30
                              Number(type[0].fourthmarkertemp)   // -5
                            )]: { 
                              color: '#2e2e2e', 
                              size: 10, 
                              label: type[0].secondmarkertemp,
                              type: 'line', 
                              fontSize: '12px',
                              visible: true
                            },
                            [this.calculateAdjustedValue(
                              Number(type[0].thirdmarkertemp),   // -18
                              Number(type[0].firstmarkertemp),   // -30
                              Number(type[0].fourthmarkertemp)   // -5
                            )]: { 
                              color: '#2e2e2e', 
                              size: 10, 
                              label: type[0].thirdmarkertemp,
                              type: 'line', 
                              fontSize: '12px',
                              visible: true
                            },
                            [this.calculateAdjustedValue(
                              Number(type[0].fourthmarkertemp),  // -5
                              Number(type[0].firstmarkertemp),   // -30
                              Number(type[0].fourthmarkertemp)   // -5
                            )]: { 
                              color: '#2e2e2e', 
                              size: 12, 
                              label: type[0].fourthmarkertemp,
                              type: 'line', 
                              fontSize: '12px',
                              visible: true
                            }
                          },
                          
                          label: `${device.temperature.toFixed(0)} C°`,
                          
                          // Reversed thresholds colors
                          thresholdsConfig: {
                            [this.calculateAdjustedValue(
                              Number(type[0].thirdholdtemp),    // -18
                              Number(type[0].firstmarkertemp),  // -30
                              Number(type[0].fourthmarkertemp)  // -5
                            )]: { color: "red", bgOpacity: 0.2 },
                            [this.calculateAdjustedValue(
                              Number(type[0].secondholdtemp),    // -20
                              Number(type[0].firstmarkertemp),   // -30
                              Number(type[0].fourthmarkertemp)   // -5
                            )]: { color: "orange", bgOpacity: 0.2 },
                            [this.calculateAdjustedValue(
                              Number(type[0].firstholdtemp),     // -30
                              Number(type[0].firstmarkertemp),   // -30
                              Number(type[0].fourthmarkertemp)   // -5
                            )]: { color: "green", bgOpacity: 0.2 }
                          },
                          
                          originalMin: 0,
                          originalMax: Math.abs(Number(type[0].fourthmarkertemp) - Number(type[0].firstmarkertemp)),
                          gaugeMin: 0,
                          gaugeMax: Math.abs(Number(type[0].fourthmarkertemp) - Number(type[0].firstmarkertemp))
                        });
                      }else{
                          br['Devices'].push(
                      {
                        ...device,
                        // adjustedValue: this.calculateAdjustedValue(device.temperature),
                        adjustedValue: device.temperature,
                          // adjustedValue: device.temperature >= 0 ? device.temperature : this.calculateAdjustedValue(device.temperature,device.firstholdtemp,device.thirdholdtemp),
                        devicetype:"Temprature",

                        markerConfig: {
                          [type[0].firstmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].firstmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].secondmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].secondmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].thirdmarkertemp]: { color: '#2e2e2e', size: 10, label: type[0].thirdmarkertemp, type: 'line', fontSize: '12px' },
                          [type[0].fourthmarkertemp]: { color: '#2e2e2e', size: 12, label: type[0].fourthmarkertemp, type: 'line', fontSize: '12px' }
                        },
                        label: `${device.temperature.toFixed(0)} C°`,
                        thresholdsConfig: {
                          [type[0].firstholdtemp]: { color: "green", bgOpacity: 0.2 },
                          [type[0].secondholdtemp]: { color: "orange", bgOpacity: 0.2 },
                          [type[0].thirdholdtemp]: { color: "red", bgOpacity: 0.2 }
  
                        } ,
                        originalMin: type[0].firstmarkertemp,
                        originalMax: type[0].fourthmarkertemp,
                        gaugeMax: type[0].fourthmarkertemp,
                        gaugeMin: type[0].firstmarkertemp
                      }
  
                      //   ...device,
                      //   // adjustedValue: this.calculateAdjustedValue(device.temperature),
                      //   adjustedValue:device.temperature,
                      //   markerConfig: {
                      //     "0": { color: '#2e2e2e', size: 12, label: "0", type: 'line', fontSize: '12px' },
                      //     "50": { color: '#2e2e2e', size: 10, label: "50", type: 'line', fontSize: '12px' },
                      //     "70": { color: '#2e2e2e', size: 10, label: "70", type: 'line', fontSize: '12px' },
                      //    "100" : { color: '#2e2e2e', size: 10, label:  "100", type: 'line', fontSize: '12px' }
                      //   },
                      //   label: `${device.temperature.toFixed(0)} C°`,
                      //   thresholdsConfig:{
                      //     "0": { color: "red", bgOpacity: 0.2 },
                      //     "50": { color: "orange", bgOpacity: 0.2 },
                      //     "60": { color: "green", bgOpacity: 0.2 }
  
                      //   },
  
                      //   gaugeMax:100, 
                      //   gaugeMin:0
                      // }
                    );
                      }
                   
                  }
                }
            

         
             
              });
              
            }
          })
console.log(this.Branches);        
          
          // Restore scroll position after update
          requestAnimationFrame(() => {
            window.scrollTo(0, this.lastScrollPosition);
          });
        }
      });
    
  }

calculateAdjustedValue(value: number, rangeMin: number, rangeMax: number): number {
  const range = Math.abs(rangeMax - rangeMin);
  return ((value - rangeMin) * range) / Math.abs(rangeMax - rangeMin);
}
  ngOnDestroy(): void {
    window.removeEventListener('resize', () => {
      this.onResize();
    });
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
 

  }
  @ViewChild('gaugeCanvas') gaugeCanvas!: ElementRef;
  @ViewChild('historyCanvas') historyCanvas!: ElementRef;


  historyChart: any;
  currentValue: number = -17;
  historyData: number[] = [];
  maxRecords: number = 40;
  threshold: number = 5;
  intervalId: any;

  //// gauge 
  gaugeChart: any;
  originalValue: number = -18; // Example: Original value (-10 to 30)
  originalMin: number = -25;
  originalMax: number = 10;
  gaugeMin: number = 0;
  gaugeMax: number = 35;


  adjustedValue: number = ((this.originalValue - this.originalMin) *
    (this.gaugeMax - this.gaugeMin)) /
    (this.originalMax - this.originalMin) + this.gaugeMin;


  async ngOnInit() {
    this.label = Number(this.originalValue.toFixed(2)) + "C°"
    this.loadtypesCollections();
    window.addEventListener('resize', () => {
      this.onResize();
    });
  //  await this.getBranchByClientId()

  }

  onResize() {
    // Trigger change detection
    this.cdRef.detectChanges();
  }
  



  // Don't forget to remove listener (in ngOnDestroy)
  

  formatTimestamp(timestamp: number): string {
    // Convert Unix timestamp to Date object (multiply by 1000 if timestamp is in seconds)
    const date = new Date(timestamp * 1000);
    return date.toLocaleString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }
  getDeviceStatus(timestamp: number): string {
    // Ensure timestamp is in milliseconds
    const timestampMs = timestamp * 1000;
    const currentTime = Date.now();
    const timeDiff = Math.floor((currentTime - timestampMs) / 1000); // Convert to seconds
    return timeDiff <= 60 ? 'Online' : 'Offline';
  }

  getStatusClass(timestamp: number): string {
    return this.getDeviceStatus(timestamp) === 'Online' ? 'status-online' : 'status-offline';
  }



  loadtypesCollections() {
    this.getCollections().subscribe(
      collections => this.ItemTypes = collections
    );
    console.log(this.ItemTypes);

  }

  getCollections(): Observable<any[]> {
    return this.http.get<{ [key: string]: any }>(
      `${this.databaseURL}/${this.collectionPath}.json?auth=${this.secret}`
    ).pipe(
      map(response => {
        if (!response) return [];
        return Object.keys(response).map(key => ({
          id: key,
          ...response[key]
        }));
      })
    );
  }


  // calculateAdjustedValue(originalValue: number,originalMin:number,originalMax:number,gaugeMax:number,gaugeMin:number): number {
  //   return ((originalValue - originalMin) *
  //     (gaugeMax - gaugeMin)) /
  //     (originalMax - this.originalMin) + gaugeMin;
  // }
//   calculateAdjustedValue(
//   originalValue: number,
//   originalMin: number,
//   originalMax: number
// ): number {
//   // Dynamically calculate gauge range based on input values
//   let gaugeMin: number;
//   let gaugeMax: number;

//   // Calculate the absolute range of original values
//   const originalRange = Math.abs(originalMax - originalMin);
  
//   // If we have negative values
//   if (originalMin < 0) {
//     // Set gaugeMin to a proportional negative value
//     gaugeMin = -originalRange;
//     // Set gaugeMax to match the positive range
//     gaugeMax = originalRange;
//   } else {
//     // If all values are positive, keep gauge range positive
//     gaugeMin = 0;
//     gaugeMax = originalRange;
//   }

//   // Apply the original formula with dynamic gauge values
//   return ((originalValue - originalMin) * (gaugeMax - gaugeMin)) / 
//          (originalMax - originalMin) + gaugeMin;
// }
  getMarkerConfig(type: any) {
    console.log(type)
    if (type === 'temp') {
      return {
        "0": { color: '#2e2e2e', size: 10, label: '0', type: 'line', fontSize: '12px' },
        "5": { color: '#2e2e2e', size: 10, label: '5', type: 'line', fontSize: '12px' },
        "7": { color: '#2e2e2e', size: 10, label: '7', type: 'line', fontSize: '12px' },
        "9": { color: '#2e2e2e', size: 8, label: '9', type: 'line', fontSize: '12px' },
        "12": { color: '#2e2e2e', size: 8, label: '12', type: 'line', fontSize: '12px' },
        "15": { color: '#2e2e2e', size: 8, label: '15', type: 'line', fontSize: '12px' },
        // "-25": { color: '#2e2e2e', size: 10, label: '-25', type: 'line', fontSize: '12px' },
        // "-18": { color: '#2e2e2e', size: 10, label: '-18', type: 'line', fontSize: '12px' },
        // "-12": { color: '#2e2e2e', size: 10, label: '-12', type: 'line', fontSize: '12px' },
        // "-5": { color: '#2e2e2e', size: 8, label: '-5', type: 'line', fontSize: '12px' },
        // "0": { color: '#2e2e2e', size: 8, label: '0', type: 'line', fontSize: '12px' },
        // "5": { color: '#2e2e2e', size: 8, label: '5', type: 'line', fontSize: '12px' },
        // "10": { color: '#2e2e2e', size: 10, label: '10', type: 'line', fontSize: '12px' },
      };
    }
    else {
      return {
        "0": { color: '#2e2e2e', size: 10, label: '0', type: 'line', fontSize: '12px' },
        "20": { color: '#2e2e2e', size: 10, label: '20', type: 'line', fontSize: '12px' },
        "40": { color: '#2e2e2e', size: 10, label: '40', type: 'line', fontSize: '12px' },
        "60": { color: '#2e2e2e', size: 8, label: '60', type: 'line', fontSize: '12px' },
        "80": { color: '#2e2e2e', size: 8, label: '80', type: 'line', fontSize: '12px' },
        "100": { color: '#2e2e2e', size: 8, label: '100', type: 'line', fontSize: '12px' },
      };
    }

  }


  // adjustedMarkerConfig(markerConfig:any,originalMin:any,originalMax:any,gaugeMax:any,gaugeMin:any){
  //  return Object.fromEntries(
  //     Object.entries(markerConfig).map(([key, value]) => [
  //       ((+key - originalMin) * 
  //        (gaugeMax - gaugeMin)) / 
  //        (originalMax - originalMin) + gaugeMin,
  //       value
  //     ])
  //   );
  // }
  adjustedMarkerConfig(markerConfig: any, originalMin: any, originalMax: any, gaugeMax: any, gaugeMin: any) {
    // Add null check
    if (!markerConfig) return {};

    return Object.fromEntries(
      Object.entries(markerConfig).map(([key, value]) => [
        ((+key - originalMin) *
          (gaugeMax - gaugeMin)) /
        (originalMax - originalMin) + gaugeMin,
        value
      ])
    );
  }

  thresholdsConfig = {
    "0": { color: "green", bgOpacity: 0.2 },
    "7": { color: "orange", bgOpacity: 0.2 },
    "13": { color: "red", bgOpacity: 0.2 }
  };

  // markerConfig = {
  //   "-10": { color: '#2e2e2e', size: 10, label: '-10', type: 'line', fontSize: '12px' },
  //   "-5": { color: '#2e2e2e', size: 10, label: '-5', type: 'line', fontSize: '12px' },
  //   "0": { color: '#2e2e2e', size: 8, label: '0', type: 'line', fontSize: '12px' },
  //   "3": { color: '#2e2e2e', size: 10, label: '3', type: 'line', fontSize: '12px' },
  //   "5": { color: '#2e2e2e', size: 8, label: '5', type: 'line', fontSize: '12px' },
  //   "7": { color: '#2e2e2e', size: 10, label: '7', type: 'line', fontSize: '12px' },
  //   "9": { color: '#2e2e2e', size: 8, label: '9', type: 'line', fontSize: '12px' },
  //   "15": { color: '#2e2e2e', size: 10, label: '15', type: 'line', fontSize: '12px' },
  //   "20": { color: '#2e2e2e', size: 8, label: '20', type: 'line', fontSize: '12px' },
  //   "30": { color: '#2e2e2e', size: 10, label: '30', type: 'line', fontSize: '12px' }
  // };

  // thresholdsConfig = {
  //   "-10": { color: "green", bgOpacity: 0.2 },
  //   "-5": { color: "green", bgOpacity: 0.2 },
  //   "5": { color: "orange", bgOpacity: 0.2 },
  //   "10": { color: "red", bgOpacity: 0.2 }
  // };
  ngAfterViewInit() {

    // this.initHistoryChart();
    this.startRealTimeUpdate();
    // Ensure view is initialized before accessing canvases
    if (this.historyCanvases) {
      this.historyCanvases.forEach((canvasRef, index) => {
        if (canvasRef && canvasRef.nativeElement) {
          this.initHistoryChart(canvasRef.nativeElement, this.Devices[index]);
        }
      });
    }
  }





  initHistoryChart(canvas: HTMLCanvasElement, device: any) {
    const ctx = canvas.getContext('2d');
    this.historyChart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: Array(this.maxRecords).fill(''),
        datasets: [{
          data: [],
          borderColor: 'rgb(75, 192, 192)',
          tension: 0.4,
          fill: false
        }]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: false }
        },
        scales: {
          y: {
            beginAtZero: true,
            max: 10
          }
        },
        animation: false
      }
    });
  }

  startRealTimeUpdate() {
    this.intervalId = setInterval(() => {
      // بيانات تجريبية: استبدلها بمصدر البيانات الفعلي
      this.currentValue = Math.random() * 10;

      // تحديث البيانات التاريخية
      this.historyData.push(this.currentValue);
      if (this.historyData.length > this.maxRecords) {
        this.historyData.shift();
      }

      // تحديث الإبرة والمخطط التاريخي
      // this.updateHistoryChart();
    }, 1000); // تحديث كل ثانية
  }


  updateHistoryChart() {
    const chart = this.historyChart;
    chart.data.datasets[0].data = [...this.historyData];
    chart.data.datasets[0].borderColor = this.currentValue >= this.threshold ? 'red' : 'rgb(75, 192, 192)';
    chart.update();
  }

  getGaugeSize(): number {
    const screenWidth = window.innerWidth;
    
    if (screenWidth < 576) { // xs
      return 200;
    } else if (screenWidth < 768) { // sm
      return 250;
    } else if (screenWidth < 992) { // md
      return 300;
    } else { // lg and up
      return 325;
    }
  }
}
